import { Tabs } from '@mantine/core';
import * as React from 'react';
import { SystemUserGroupsPageTab } from './SystemUserGroupsPageTab';
import { SystemUserRolesPageTab } from './SystemUserRolesPageTab';

export const SystemUserManagementPage = () => {
    const [tabValue, setTabValue] = React.useState<string | null>('systemUserGroups');

    return (
        <div className={'main-window-content'}>
            <Tabs value={tabValue} onChange={(newValue) => setTabValue(newValue)} h={"100%"}>
                <Tabs.List>
                    <Tabs.Tab value={'systemUserGroups'}>System User Groups</Tabs.Tab>
                    <Tabs.Tab value={'systemUserRoles'}>System User Roles</Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value={'systemUserGroups'} h={"100%"}>
                    <SystemUserGroupsPageTab />
                </Tabs.Panel>
                <Tabs.Panel value={'systemUserRoles'}>
                    <SystemUserRolesPageTab />
                </Tabs.Panel>
            </Tabs>
        </div>
    );
};


